module.exports = __webpack_public_path__ + "img/21.73d55336.png";